import { View } from "react-native";
import { TouchableRipple } from "react-native-paper";
import WebView from "react-native-webview";
import { useTailwind } from "tailwind-rn";

import { LatLng } from "../../types";

type Props = {
  position: LatLng | null;
  onPress: () => void;
};

const baseUrl = "https://checkout-staging.cuanto.app/summary-map";

export default function SummaryMap({ position, onPress }: Props) {
  const tailwind = useTailwind();

  const uri = position
    ? `${baseUrl}?latitude=${position.latitude}&longitude=${position.longitude}`
    : baseUrl;

  return (
    <TouchableRipple onPress={onPress}>
      <View
        style={tailwind("h-40 overflow-hidden rounded-md")}
        pointerEvents="none"
      >
        <WebView source={{ uri }} />
      </View>
    </TouchableRipple>
  );
}
